export const BRAND_NAME = 'Sky11';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = '786sky.com';
export const OPERATORID = 'HypexDemo';
export const PROVIDER_ID = 'BetFair';
